import React, { Suspense, useMemo } from "react";
import { useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import Loader from "components/Loader";
import { withTranslation } from "react-i18next";
import constants from "../../../constants";
import { decodeId, getStorage, setStorage } from "utils";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { useGetOfficeStaffInformationList } from "repositories/office-repository";
import StaffCardView from "./components/StaffCardView";
import OfficeCardView from "./components/OfficeCardView";
import PageWrapperStaffInformation from "./components/PageWrapperStaffInformation";
const PAGE_SIZE = 10;
const OfficeStaffInformation = ({ t, match, location }) => {
  const cachedActiveTab = getStorage(
    constants.notes.cache.officeStaffInformation,
  );
  const officeDetail = location.state;
  const [activeTab, setActiveTab] = useState(
    cachedActiveTab?.activeTab ? cachedActiveTab.activeTab : 1,
  );
  const [pageNo, setPageNo] = useState(1);

  const tabName = constants.officeStaffInformation;
  const { data, isLoading, isRefetching } = useGetOfficeStaffInformationList(
    {
      officeId: decodeId(match.params.officeId),
      pageSize: PAGE_SIZE,
      pageNumber: pageNo,
      adminList: activeTab === tabName.ownerManager,
    },
    { enabled: activeTab !== tabName.office },
  );
  const manageTab = (tab) => {
    window.scrollTo(0, 0);
    setPageNo(1);
    setActiveTab(tab);
    setStorage(constants.notes.cache.officeStaffInformation, {
      activeTab: tab,
    });
  };
  const isOwnerManagerTab = activeTab === tabName.ownerManager;
  const staffData = useMemo(() => {
    if (isOwnerManagerTab) {
      const owner = data?.data?.owner;
      const users = data?.data?.users || [];
      return owner ? [owner, ...users] : users;
    }
    return data?.data?.users || [];
  }, [data?.data, isOwnerManagerTab]);

  const userList = (
    <StaffCardView
      isLoading={isLoading}
      isRefetching={isRefetching}
      staffData={staffData}
    >
      {staffData?.length > 0 && (
        <PaginationProvider
          pagination={paginationFactory({
            custom: true,
            sizePerPage: PAGE_SIZE,
            totalSize: data?.pagination?.totalItems,
            page: pageNo,
            onPageChange: setPageNo,
          })}
        >
          {({ paginationProps, paginationTableProps }) => {
            return (
              <div className="data-table-block">
                <div style={{ display: "none" }}>
                  <BootstrapTable
                    keyField="id"
                    data={[]}
                    columns={[{ text: "sometext" }]}
                    {...paginationTableProps}
                  />
                </div>
                <div className={"pagnation-block "}>
                  {data?.pagination?.totalItems > PAGE_SIZE && (
                    <PaginationListStandalone {...paginationProps} />
                  )}
                </div>
              </div>
            );
          }}
        </PaginationProvider>
      )}
    </StaffCardView>
  );

  return (
    <PageWrapperStaffInformation
      activeTab={activeTab}
      tabName={tabName}
      manageTab={manageTab}
      title={t("accountOwner.officeStaffInformation")}
      officeName={officeDetail?.officeName}
    >
      <TabContent activeTab={activeTab}>
        <Suspense fallback={<Loader />}>
          <TabPane tabId={1}>
            <OfficeCardView office={officeDetail} />
          </TabPane>
          <TabPane tabId={2}>{userList}</TabPane>
          <TabPane tabId={3}>{userList}</TabPane>
        </Suspense>
      </TabContent>
    </PageWrapperStaffInformation>
  );
};
export default withTranslation()(OfficeStaffInformation);
